module.exports = __webpack_public_path__ + "img/logo.8ec1cf97.png";